/** Parse account userId from Zoom JWT user_identity / userKey: "{userId}_{random5or6}". */
export function parseCedUserIdFromIdentity(identity) {
  if (!identity || typeof identity !== 'string') return null;
  const trimmed = identity.trim();
  const match = trimmed.match(/^(.+)_([a-zA-Z0-9]{5,})$/);
  return match ? match[1] : null;
}

export function getParticipantCedUserId(participant) {
  if (!participant || typeof participant !== 'object') return null;
  return parseCedUserIdFromIdentity(participant.userKey || participant.userIdentity);
}

export function resolveMyCedUserId(reduxUser, currentParticipant) {
  const fromRedux = reduxUser?._id || reduxUser?.cedUserId;
  if (fromRedux != null && String(fromRedux).trim()) {
    return String(fromRedux).trim();
  }
  return getParticipantCedUserId(currentParticipant);
}

export function findSameCedUserParticipants(users, cedUserId, excludeZoomUserId) {
  if (!cedUserId || !Array.isArray(users)) return [];
  return users.filter((participant) => {
    if (excludeZoomUserId != null && participant.userId === excludeZoomUserId) {
      return false;
    }
    return getParticipantCedUserId(participant) === cedUserId;
  });
}

export function hasSameUserWithMicOn(users, cedUserId, excludeZoomUserId) {
  return findSameCedUserParticipants(users, cedUserId, excludeZoomUserId).some(
    (participant) => participant.muted === false,
  );
}

export function hasSameCedUserInList(participants, cedUserId, excludeZoomUserId) {
  return findSameCedUserParticipants(participants, cedUserId, excludeZoomUserId).length > 0;
}

export function normalizeParticipantEventPayload(payload) {
  if (payload == null) return [];
  return Array.isArray(payload) ? payload : [payload];
}

export function participantUserIdsMatch(a, b) {
  if (a == null || b == null) return false;
  return String(a) === String(b);
}

/** Keep the local tile muted while this device intends the microphone to stay off. */
export function withLocalMuteIntent(users, myZoomUserId, isAudioOn) {
  if (isAudioOn || myZoomUserId == null || !Array.isArray(users)) return users;
  const self = users.find((participant) => participantUserIdsMatch(participant.userId, myZoomUserId));
  if (!self || self.muted === true) return users;
  return users.map((participant) =>
    participantUserIdsMatch(participant.userId, myZoomUserId)
      ? { ...participant, muted: true }
      : participant,
  );
}
